import firebase from 'firebase';
import * as constants from 'constants';
import storage from './storage';
import { cache } from './cache';

//making sure to inilize the apps
let db = cache.get('db_ref');
export const connect = async db_key => {
  !firebase.apps.length && firebase.initializeApp(constants.DB_CONFIG);

  db = firebase.database();
  cache.set('db_ref', db);
  cache.set('fb_storage_ref', firebase.storage());
  // uploader.initialize();
  if (!db_key) {
    return;
  }
  try {
    if (!(await storage.get('db_connected'))) {
      await firebase.auth().signInWithCustomToken(db_key);
      storage.set('db_connected', true);
      console.log('DB first Time connection');
    }
  } catch (e) {
    console.error('db_error... ', e);
  }
};

export const signOut = async auth => {
  console.log('inside sign out, did you signout ?');
  await db
    .ref(`user_session/${auth.id}/${auth.session_id}/online`)
    .onDisconnect()
    .cancel();
  db.goOffline();
  firebase.auth().signOut();
  firebase.app().delete();
};

export const off = async (path, type, cb) => db.ref(path).off(type, cb);
export const get = async (path, page_size) => {
  if (page_size) {
    return (await db
      .ref(path)
      .limitToLast(page_size)
      .once('value')).val();
  }
  return (await db.ref(path).once('value')).val();
};
export const key = (path = 'key') => db.ref(path).push().key;
export const set = (path, value, disconnect_value) => {
  const ref = db.ref(path);
  disconnect_value !== undefined && ref.onDisconnect().set(disconnect_value);
  return ref.set(value);
};
export const update = (payload, disconnect_payload) => {
  const ref = db.ref();
  disconnect_payload !== undefined && ref.onDisconnect().update(disconnect_payload);
  return ref.update(payload);
};

export const time = () => firebase.database.ServerValue.TIMESTAMP;

export const watchAdded = (p, cb, page_size) => watch(p, cb, page_size, 'child_added');
export const watchChanged = (p, cb, page_size) => watch(p, cb, page_size, 'child_changed');
export const watchRemoved = (p, cb, page_size) => watch(p, cb, page_size, 'child_removed');
export const watch = (path, callback, page_size, type = 'value') => {
  const ref = db.ref(path);
  if (page_size) {
    ref.limitToLast(page_size).on(type, payload => callback(payload.val()));
  } else {
    ref.on(type, payload => callback(payload.val()));
  }
  return ref;
};

export const loadAndWatch = async (path, { once, added, changed, removed, page_size }) => {
  let initialDataLoaded = false;
  const ref_added = added && watchAdded(path, val => initialDataLoaded && added(val));
  const ref_changed = changed && watchChanged(path, val => changed(val));
  const ref_removed = removed && watchRemoved(path, val => removed(val));
  once && (initialDataLoaded = await get(path, page_size)) && once(initialDataLoaded);
  return { added: ref_added, changed: ref_changed, removed: ref_removed };
};

export const loadAndWatchPage = async (path, { once, page_size, pointer }) => {
  const ref = db.ref(path);
  page_size = page_size || constants.PAGE_SIZE;
  page_size = page_size / 2;

  once &&
    ref
      .orderByKey()
      .endAt(pointer)
      .limitToLast(page_size)
      .once('value', snapshot1 => {
        ref
          .orderByKey()
          .startAt(pointer)
          .limitToFirst(page_size)
          .once('value', snapshot2 => {
            once({ ...snapshot1.val(), ...snapshot2.val() });
          });
      });
  return ref;
};

export const loadPrevPage = async (path, { once, page_size, pointer }) => {
  const ref = db.ref(path);
  page_size = page_size || constants.PAGE_SIZE;
  once &&
    ref
      .orderByKey()
      .endAt(pointer)
      .limitToLast(page_size)
      .once('value', snapshot => {
        let messages = snapshot.val();
        delete messages[pointer];
        once(messages);
      });
  return ref;
};

export const loadNextPage = async (path, { once, page_size, pointer }) => {
  const ref = db.ref(path);
  page_size = page_size || constants.PAGE_SIZE;

  once &&
    ref
      .orderByKey()
      .startAt(pointer)
      .limitToFirst(page_size)
      .once('value', snapshot => {
        let messages = snapshot.val();
        delete messages[pointer];
        once(messages);
      });
  return ref;
};

// {
//   "rules": {
//      ".read":true,
//     "users": {
//       "$uid": {
//         ".read": "auth != null && auth.uid == $uid",
//    			"online": {
//         ".write": "data.parent().child('id').exists()"
//         }
//       }
//     },
//     "convs": {
//       "$conv_id": {
//         ".read": "data.child('members').child(auth.uid).exists() || data.child('info').child('members').child(auth.uid).exists() ",
//         ".write": "data.child('members').child(auth.uid).exists() || data.child('info').child('members').child(auth.uid).exists() "
//       }
//     },
//     "user_conv": {
//       "$uid":{
//         ".read": "auth != null && auth.uid == $uid",
//         "$conv_id": {
//             "read_msg": {
//               ".write": "auth != null && auth.uid == $uid"
//             },
//             "last_read_msg_id": {
//               ".write": "auth != null && auth.uid == $uid"
//             }
//         }
//       }
//     },
//       "user_session": {
//         "$uid": {
//           "$session_id": {
//             ".read": "auth != null && auth.uid == $uid",
//               "online": {
//                 ".write": "auth != null && auth.uid == $uid && data.parent().child('id').exists()"
//               },
//                 "badge": {
//                 ".write": "auth != null && auth.uid == $uid && data.parent().child('id').exists()"
//               }
//           }
//         }
//       }
//   }
// }



// WEBPACK FOOTER //
// ./src/utils/db.js